export const FETCH_USERS_COMPACT_REQUEST = '@lms/FETCH_USERS_COMPACT_REQUEST';
export const FETCH_USERS_COMPACT_SUCCESS = '@lms/FETCH_USERS_COMPACT_SUCCESS';
export const FETCH_USERS_COMPACT_FAILED = '@lms/FETCH_USERS_COMPACT_FAILED';
